import axios from "axios";
import { addErrorNotification } from "../utils/notifications";

const baseService = axios.create({
	baseURL: "/api/v1.0/"
});
// export const getCaptcha = () => base.get('/auth/recaptcha')
//     .then(res => res.data)
export default baseService;



// WEBPACK FOOTER //
// ./src/services/base.js